import React, {useEffect, useState} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';
import {useTranslation} from 'react-i18next';

const MAX_STATEMENT_LENGTH = 2000;

// Modal de edición del `statement` de un hecho. En v1 sólo se edita el texto (el endpoint
// PATCH soporta statement; cambiar el tipo no está soportado todavía en el backend).
export function FactEditModal({isOpen, fact, saving, toggle, onSave}) {
    const {t} = useTranslation();
    const [statement, setStatement] = useState('');

    // Resetea el draft sólo al abrir el modal o al cambiar de hecho (por id), NO cada vez que
    // el objeto `fact` se re-crea (ej. si el mismo hecho se actualiza por otra acción mientras
    // se edita): así no se pisa lo que el usuario está tipeando.
    useEffect(() => {
        setStatement(fact ? fact.statement || '' : '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fact ? fact.id : null, isOpen]);

    const trimmed = statement.trim();
    const valid = trimmed.length > 0 && trimmed.length <= MAX_STATEMENT_LENGTH;

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>{t('client_memory.edit_modal.title')}</ModalHeader>
            <ModalBody>
                <div className="modal-section">
                    <div className="form-row">
                        <label>{t('client_memory.edit_modal.statement_label')}</label>
                        <textarea
                            className="form-control"
                            rows={4}
                            value={statement}
                            maxLength={MAX_STATEMENT_LENGTH}
                            onChange={(e) => setStatement(e.target.value)}
                        />
                        <span className="cmem-char-count">{`${trimmed.length}/${MAX_STATEMENT_LENGTH}`}</span>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle} disabled={saving}>
                    {t('client_memory.action.cancel')}
                </Button>
                <button type="button" className="btn -alt" disabled={!valid || saving}
                        onClick={() => onSave(fact, trimmed)}>
                    {t('client_memory.action.save')}
                </button>
            </ModalFooter>
        </Modal>
    );
}
